module.exports = __webpack_public_path__ + "static/media/README.9c7ce475.md";